import { ModalRef } from './../controls/modal/modal-ref';
import { UserInfo } from './../../model/User';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserFormTab, UserFormType } from '../user-form/user-form.component';
import { ModalConfig } from '../controls/modal/modal-config';
import { Utils } from 'src/app/utils';

@Component({
    selector: 'app-header-profile',
    templateUrl: './header-profile.component.html',
    styleUrls: ['./header-profile.component.css'],
    standalone: false
})
export class HeaderProfileComponent implements OnInit {

  UserFormTab = UserFormTab;
  profileForm:FormGroup = new FormGroup({});
  currentUserAuthInfo:UserInfo;
  formType:UserFormType = UserFormType.LOCAL;

  constructor(private modalRef: ModalRef,
              public modalConfig: ModalConfig) { }

  ngOnInit(): void {
    this.currentUserAuthInfo = this.modalConfig.data.currentUserAuthInfo;
    this.formType = Utils.isSuperuserRole(this.currentUserAuthInfo) || this.currentUserAuthInfo.settings.authenticationMethod == 'local' ? UserFormType.LOCAL : UserFormType.OTDS;
  }

  updateUserForm(userForm:FormGroup): void {
    this.profileForm = userForm;
  }

  save(): void {
    this.modalRef.close(this.profileForm);
  }

  close(error?:boolean): void {
    this.modalRef.close();
  }
}
